import React, { Fragment } from "react";
import cn from "classnames";
import "./InformationTable.less";

interface InformationTableProps {
    data: {
        label: string;
        strikethrough?: boolean;
        value: string;
    }[];
    withBorder?: boolean;
    withHr?: boolean;
}

const InformationTable: React.FC<InformationTableProps> = ({ data, withHr = true, withBorder = false }) => (
    <div className={cn("information-table__container", { "information-table__border": withBorder })}>
        {data.map(({ label, value, strikethrough }, i, arr) => (
            <Fragment key={`information-table-item-${label}-${i}`}>
                <span className="information-table__label">{label}</span>
                <span
                    className={cn("information-table__value", {
                        "information-table__value--strike": !!strikethrough,
                    })}
                    data-di-mask
                >
                    {value}
                </span>
                {withHr && arr.length - 1 !== i && <div className="information-table__hr"></div>}
            </Fragment>
        ))}
    </div>
);

export default InformationTable;
